{"version":"26.10.14-local-solo","id":"at.softline.lagerhaus.horitschon.softline","name":"Softline"}